<template>
  <div v-if="asyncDataStatus_ready" v-resize="onResize">

    <v-row justify="space-between">
      <v-col cols="6" md="3">
        <v-text-field
          v-if="this.tables.length"
          placeholder="Išči..."
          append-icon="mdi-search"
          v-model="filter"
          @keydown.esc="filter=''"
        ></v-text-field>
      </v-col>
      <v-col cols="auto">
        <v-btn
          color="#0F998E"
          class="white--text"
          @click="openNew"
        >
          Nova miza
          <v-icon right dark>mdi-plus</v-icon>
        </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col style="color: #0F998E">
        Razvrsti: <ButtonActionSortAZ class="ml-2" @click="sort('AZ')" /><ButtonActionSortZA class="mr-2" @click="sort('ZA')" /><ButtonActionSortLocationsAZ class="mx-2" @click="sort('LocationsAZ')" /><ButtonActionSortLocationsZA class="mx-2" @click="sort('LocationsZA')" />
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        Prostori:
        <br v-if="screenSizeIsSmall">
        <v-btn
          color="#0F998E"
          class="white--text ml-3"
          @click="selectAllLocations"
        >
          Izberi vse
        </v-btn>
        <v-btn
          color="#0F998E"
          class="white--text ml-3"
          @click="selectNoLocations"
        >
          Izberi nobeno
        </v-btn>
      </v-col>
      <v-col v-if="screenSizeIsSmall">
        <v-select
          v-model="selectedLocationIds"
          :items="locations"
          :menu-props="{ maxHeight: '400' }"
          label="Lokacije"
          multiple
          hint="Izberite željene skupine"
          item-text="name"
          item-value="id"
        ></v-select>
      </v-col>
      <v-col cols="12 pt-0" v-else>
        <v-btn
          v-for="location of locations"
          :key="location.id"
          :color="location.color"
          class="mr-3 mb-3"
          :class="location.selected ? 'white--text' : ''"
          @click="toggleLocation(location)"
          :outlined="!location.selected"
        >
          {{location.name}}
        </v-btn>
      </v-col>
    </v-row>

    <v-row v-if="this.tables.length">
      <v-col>
        <v-simple-table
          fixed-header
        >
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">
                  Naziv
                </th>
                <th class="text-left" v-if="!screenSizeIsSmall">
                  Prostor
                </th>
                <th class="text-left" v-if="!screenSizeIsSmall">
                  Se ne prikazuje
                </th>
                <th class="text-left" v-if="!screenSizeIsSmall">
                  Klient
                </th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="table in filteredTables"
                :key="table.id"
              >
                <td :style="{'border-left': `5px solid ${table.location_color}`}">{{ table.name }}</td>
                <td v-if="!screenSizeIsSmall">{{ table.location_name }}</td>
                <td v-if="!screenSizeIsSmall"> <ActiveIcon :value="table.type" /> </td>
                <td v-if="!screenSizeIsSmall"> <ActiveIcon :value="table.client" /> </td>
                <td class="text-right">
                  <!-- <ButtonActionEdit @click="$router.push({name: 'MyCompanyTablesEdit', params: {id: table.id}})" /> -->
                  <ButtonActionEdit @click="setCurrentId(table.id)" />
                  <ButtonActionDelete @click="showDeleteTableModal = true; deleteTable = table" />
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-col>
    </v-row>
    <v-row
      v-else
    >
      <v-col cols="12">
        <p class="text-center">
          Ni rezultatov iskanja. Za dodajanje nove mize uporabite gumb desno zgoraj.
        </p>
      </v-col>
    </v-row>

    <ConfirmDialog
      title="Brisanje mize"
      text="Ali ste prepričani, da želite izbrisati mizo? Podatki bodo trajno izbrisani."
      okBtnText="Briši"
      v-model="showDeleteTableModal"
      @confirmed="remove(deleteTable)"
    />

    <MyCompanyTablesNew
      ref="mycompanytablesnew"
      @close="currentId = null; initData()"
    />
    <MyCompanyTablesEdit
      v-if="currentId !== null"
      :id="currentId ? currentId : null"
      @close="currentId = null;"
    />

  </div>
</template>

<script>
import { mapActions } from 'vuex'
import asyncDataStatus from '@/mixins/asyncDataStatus'
import responsive from '@/mixins/responsive'
import { siIncludes } from '@/utils/str'
import { loadItems, deleteItem } from '@/utils/crudFunctions'
import ConfirmDialog from '@/components/ConfirmDialog'
import ButtonActionSortAZ from '@/components/ButtonActionSortAZ'
import ActiveIcon from '@/components/ActiveIcon'
import MyCompanyTablesEdit from '@/pages/MyCompanyTablesEdit'
import MyCompanyTablesNew from '@/pages/MyCompanyTablesNew'
import ButtonActionSortZA from '@/components/ButtonActionSortZA'
import ButtonActionSortLocationsAZ from '@/components/ButtonActionSortLocationsAZ'
import ButtonActionSortLocationsZA from '@/components/ButtonActionSortLocationsZA'
import ButtonActionEdit from '@/components/ButtonActionEdit'
import ButtonActionDelete from '@/components/ButtonActionDelete'
import { objectToArray } from '@/utils/object'

export default {
  components: {
    ConfirmDialog,
    ButtonActionSortAZ,
    ActiveIcon,
    MyCompanyTablesEdit,
    MyCompanyTablesNew,
    ButtonActionSortZA,
    ButtonActionSortLocationsAZ,
    ButtonActionSortLocationsZA,
    ButtonActionEdit,
    ButtonActionDelete
  },
  mixins: [
    asyncDataStatus,
    responsive
  ],
  data () {
    return {
      filter: '',
      sortMethod: null,
      highlightLocations: false,
      showDeleteTableModal: false,
      deleteTable: null,
      locations: [],
      selectedLocationIds: [],
      currentId: null,
    }
  },
  computed: {
    tables () {
      let tables = objectToArray(this.$store.state.tables.items)
      if (this.sortMethod) {
        return tables.sort((a, b) => {
          if (this.sortMethod === 'AZ') {
            return a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1
          }
          if (this.sortMethod === 'ZA') {
            return a.name.toLowerCase() > b.name.toLowerCase() ? -1 : 1
          }
          if (this.sortMethod === 'LocationsAZ') {
            return a.location_name.toLowerCase() > b.location_name.toLowerCase() ? 1 : -1
          }
          if (this.sortMethod === 'LocationsZA') {
            return a.location_name.toLowerCase() > b.location_name.toLowerCase() ? -1 : 1
          }
        })
      }
      return tables.sort((a, b) => {
        if (!a.location_name || !b.location_name) {
          return 0
        }
        if (a.location_name.toLowerCase() > b.location_name.toLowerCase()) {
          return 1
        } else if (a.location_name.toLowerCase() < b.location_name.toLowerCase()) {
          return -1
        }

        if (a.name.toLowerCase() < b.name.toLowerCase()) {
          return -1
        } else if (a.name.toLowerCase() > b.name.toLowerCase()) {
          return 1
        } else { // nothing to split them
          return 0
        }
      })
    },
    filteredTables () {
      return this.tables.filter(item => {
        return siIncludes({ haystack: `${item.name}`, needle: this.filter }) && this.isInActiveLocation(item)
      })
    }
  },
  methods: {
    ...mapActions('tables', ['loadItems', 'deleteItem']),
    ...mapActions('locations', { loadLocations: 'loadItems' }),
    openNew () {
      this.$refs.mycompanytablesnew.open()
    },
    setCurrentId (id) {
      this.currentId = id
    },
    remove (item) {
      deleteItem(item, this)
    },
    sort (method) {
      this.sortMethod = method
      if (method === 'LocationsAZ' || method === 'LocationsZA') {
        this.highlightLocations = true
      } else {
        this.highlightLocations = false
      }
    },
    selectAllLocations () {
      this.locations = this.locations.map(cat => {
        cat.selected = true
        return cat
      })
      this.selectedLocationIds = this.locations.map(c => c.id)
    },
    selectNoLocations () {
      this.locations = this.locations.map(cat => {
        cat.selected = false
        return cat
      })
      this.selectedLocationIds = []
    },
    toggleLocation (location) {
      this.locations = this.locations.map(cat => {
        if (cat.id === location.id) {
          cat.selected = !cat.selected
        }
        return cat
      })
      this.selectedLocationIds = this.locations.filter(c => !!c.selected).map(c => c.id)
    },
    isInActiveLocation (table) {
      return this.selectedLocationIds.includes(table.location)
    },
    async initData () {
      if (!this.$store.state.businessUnits.currentBusinessUnit) {
        this.$notify({ type: 'error', text: 'Potrebna je vsaj ena aktivna poslovna enota' })
      } else {
        this.checkScreenSize()
        await this.loadLocations()
        this.locations = objectToArray(this.$store.state.locations.items).map(l => {
          l.selected = true
          return l
        })
        this.selectedLocationIds = this.locations.map(l => l.id)
        await loadItems(this)
      }
    }
  },
  created () {
    this.initData()
  }
}
</script>
